import { render, staticRenderFns } from "./lawsuit-follow.vue?vue&type=template&id=25bcb184&scoped=true"
import script from "./lawsuit-follow.vue?vue&type=script&lang=ts"
export * from "./lawsuit-follow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bcb184",
  null
  
)

export default component.exports